// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"92370129","145":"1a6b55f7","227":"b3114535","266":"18825014","377":"29b63ef5","494":"ed520ea2","879":"7e49fdcd","880":"4f147f45","888":"7d79a746","894":"7e5fac11"}[chunkId] + ".chunk.js";
};